import React from 'react';
import Helmet from 'react-helmet';
import { convertHttps, roundUptoDigits } from '../../utils/helper';
import { langCodeAllowed } from '../../locales';
let currencyCode = '';
const ProductHelmet = props => {
  const {
    productData,
    firstFrameFree,
    firstFrameFreeDLPrice,
    pathname,
    lenskartPrice,
    lenskartPriceWithGST,
    localeInfo,
    location,
    redisCommonData,
  } = props;
  const {
    id,
    sku,
    review,
    avgRating,
    thumbnailImage,
    seoTitle,
    seoMetaDescription,
    seoMetaKeywords,
    seoMetaCanonical,
    breadcrumb,
    imageUrls,
    brandName,
    modelName,
    url,
    prices,
  } = productData;
  const { domainUrl, domain } = localeInfo;
  const { DEFAULT_PRODUCT_HELMET_DATA = {} } = redisCommonData;
  const reviews = review && review.reviews ? review.reviews : [];
  currencyCode = prices && prices.length > 0 ? prices[0].currencyCode : '';
  const appUrl = `https://lenskart.onelink.me/747387224?pid=twitter_app_card&af_dp=${domain}${pathname}&af_web_dp=${domain}${pathname}`;
  const productpricewithgst = lenskartPriceWithGST || lenskartPrice;
  const bCrumbSchema =
    (breadcrumb &&
      breadcrumb.length &&
      breadcrumb.map((item, index) => {
        return (
          item.link &&
          item.label !== 'Mobile' && {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@id': `${domain}/${String(item.link)
                .replace(`${domainUrl}`, '')
                .replace('mobile/', '')}`,
              name: item.label,
            },
          }
        );
      })) ||
    [];
  const reviewSchema =
    (reviews.length &&
      reviews.map(item => {
        return {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: decodeURIComponent(item.reviewee),
          },
          itemReviewed: {
            '@type': 'Person',
            name: decodeURIComponent(item.reviewee),
          },
          datePublished: item.reviewDate ? decodeURIComponent(item.reviewDate).split(' ')[0] : null,
          description: decodeURIComponent(item.reviewDetail),
          name: decodeURIComponent(item.reviewTitle),
          reviewRating: {
            '@type': 'Rating',
            ratingValue: decodeURIComponent(item.noOfStars),
          },
        };
      })) ||
    [];
  const hrefLink = location.search
    ? `${localeInfo.domain}${pathname}${location.search}`
    : `${localeInfo.domain}${pathname}`;
  const keysArray = Object.keys(langCodeAllowed);
  const linkArray = [
    { rel: 'canonical', href: `${domain}${pathname}` },
    { rel: 'alternate', href: `${domain}${pathname}` },
  ];
  keysArray.forEach(keys =>
    linkArray.push({
      rel: 'alternate',
      hrefLang: `${langCodeAllowed[keys]?.hrefLang}`,
      href: hrefLink,
    })
  );
  let metaArray = [
    { name: 'description', content: seoMetaDescription },
    { name: 'keywords', content: seoMetaKeywords },
    { name: 'robots', content: 'INDEX,FOLLOW' },
    { property: 'og:site_name', content: 'Lenskart.com' },
    { property: 'og:title', content: seoTitle },
    { property: 'og:description', content: seoMetaDescription },
    { property: 'og:url', content: seoMetaCanonical },
    { property: 'og:type', content: 'lenskartwebsite:product' },
    { property: 'og:image', content: imageUrls.length ? convertHttps(imageUrls[0]) : '' },
    { property: 'og:availability', content: productData.qty > 0 ? 'In Stock' : 'Out of Stock' },
    { property: 'lenskartwebsite:price:amount', content: lenskartPrice },
    { name: 'twitter:description', content: seoMetaDescription },
    { property: 'twitter:image', content: imageUrls.length ? convertHttps(imageUrls[0]) : '' },
    { name: 'twitter:app:url:iphone', content: appUrl },
    { name: 'twitter:app:url:ipad', content: appUrl },
    { name: 'twitter:app:url:googleplay', content: appUrl },
  ];
  if (localeInfo.countryCode === 'sg') {
    metaArray = metaArray.filter(item => item.name !== 'robots');
  }
  return (
    <Helmet
      link={linkArray}
      meta={metaArray}
      script={[
        ...[
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              '@context': 'https://schema.org/',
              '@type': 'Product',
              name: `${brandName} ${modelName}`,
              image: convertHttps(thumbnailImage) || DEFAULT_PRODUCT_HELMET_DATA?.image,
              description: seoMetaDescription || DEFAULT_PRODUCT_HELMET_DATA?.description,
              mpn: id || DEFAULT_PRODUCT_HELMET_DATA?.mpn,
              sku: sku || DEFAULT_PRODUCT_HELMET_DATA?.sku,
              brand: {
                '@type': 'Brand',
                name: brandName || DEFAULT_PRODUCT_HELMET_DATA?.brandName,
              },
              model: modelName,
              itemCondition: 'https://schema.org/NewCondition',
              offers: {
                '@type': 'Offer',
                priceCurrency: currencyCode + '',
                price: firstFrameFree ? firstFrameFreeDLPrice + '' : productpricewithgst + '',
                priceValidUntil : DEFAULT_PRODUCT_HELMET_DATA?.priceValidUntil && eval(DEFAULT_PRODUCT_HELMET_DATA?.priceValidUntil) || `${new Date().getFullYear()+1}-${(new Date().getMonth()+1) > 9 ? (new Date().getMonth()+1) : ('0' + (new Date().getMonth()+1))}-${new Date().getDate()}`,
                itemCondition: 'https://schema.org/NewCondition',
                availability:
                  productData.qty > 0
                    ? 'https://schema.org/InStock'
                    : 'https://schema.org/OutOfStock',
                url: url || DEFAULT_PRODUCT_HELMET_DATA?.url,
              },
              aggregateRating:
                avgRating && parseInt(avgRating) + '' !== 'NAN' && reviews.length
                  ? {
                      '@type': 'AggregateRating',
                      ratingValue: roundUptoDigits(avgRating, 1),
                      reviewCount: reviews.length,
                      itemReviewed: {
                        "@type": "Organization",
                        "name" : "Anonymous"
                      },
                    }
                  : DEFAULT_PRODUCT_HELMET_DATA?.aggregateRating,
              review: reviewSchema.length ? reviewSchema : DEFAULT_PRODUCT_HELMET_DATA?.review,
            }),
          },
        ],
        ...(bCrumbSchema.length
          ? [
              {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'BreadcrumbList',
                  itemListElement: bCrumbSchema,
                }),
              },
            ]
          : []),
      ]}
      title={
        !seoTitle
          ? `${productData.brandName} ${productData.id} at ${lenskartPrice} | Buy`
          : seoTitle
      }
    ></Helmet>
  );
};

export default ProductHelmet;
